import styled from "styled-components";

export const AttendancePeriodsContainer = styled.div`
  h4 {
    font-size: 20px;
  }
`;

export const DetailContainer = styled.div`
  p {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 10px;
    padding: 0;
  }
`;
